@use '../../../styles/tokens' as *;
@use '../../../styles/utilities' as util;

.body {
  display: flex;
  flex-direction: column;
  background: $colorWhite;
}

.body > * + * {
  border-top: 1px solid $colorLightestGray;
}

// Both lines render inside the section's title slot so they stack; the meta resets the slot's bold
// heading style.
.heading {
  @include util.flexColumn;
  gap: $gapExtraSnug;
}

.receiptHeading {
  @include util.flexColumn;
}

.title {
  font-size: $appNavFontSize;
}

.receiptHeading .title {
  color: $colorPrimary;
}

// The portfolio under a receipt's property name, and the charge opposite it.
.sublabel,
.charged {
  font-size: $compactFontSize;
  font-weight: normal;
  color: $colorDarkestGray;
}

.charged {
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.meta {
  font-size: $paragraphFontSize;
  font-weight: normal;
  color: $colorDarkestGray;
}

.headerTotals {
  @include util.flexRow;
  gap: $gapSnug;
}

.needsAttention {
  @include util.flexRow;
  gap: $gapExtraSnug;
  color: $colorDarkRed;
}

.subtotal {
  @include util.flexRow;
  gap: $gapSnug;
}

.subtotalLabel {
  color: $colorDarkestGray;
}

.subtotalValue {
  font-weight: $boldFontWeight;
  font-variant-numeric: tabular-nums;
}
